import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getSpendingAccountBalanceReport = payload =>
  call(websocketFetch, 'get_group_spending_account_balance_report', payload);
